/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type ShipmentsLandTransportManagementPaginatedListTransportMethod = typeof ShipmentsLandTransportManagementPaginatedListTransportMethod[keyof typeof ShipmentsLandTransportManagementPaginatedListTransportMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsLandTransportManagementPaginatedListTransportMethod = {
  CHARTER: 'CHARTER',
  CHARTER_NOT_SAME_DAY: 'CHARTER_NOT_SAME_DAY',
  CHARTER_SAME_DAY: 'CHARTER_SAME_DAY',
  CONSOLIDATION: 'CONSOLIDATION',
  DRAYAGE: 'DRAYAGE',
} as const;
